<template>
  <div class="chart_xright">
    <div class="charts" style="width: 974px; height: 161px" ref="chartb"></div>
  </div>
</template>

<script>
import { SearchKey } from "@/assets/server/api";
const echarts = require("echarts");
export default {
  props: ["nextDuring"],
  data() {
    return {
      value: "",
    };
  },
  watch: {
    deep: true,
    nextDuring(val) {
      // this.nextDuring = val;
      //
    },

    //
  },
  created() {},
  mounted() {
    // this.daojishi();
    this.initChartsb();
  },
  methods: {
    initChartsb() {
      this.lineChart = echarts.init(this.$refs.chartb);
      let option = {
        color: ["#80FFA5", "#00DDFF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>TTOS Sypply:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[0].value +
              "</span>" +
              "</div>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Staked:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[1].value +
              "</span>" +
              "</div>";
            return str;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "2%",
          right: "0%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.daysx,
            show: false,
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            show: false,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#A5BF4D",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#A5BF4D",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 231, 154, 1, [
                {
                  offset: 0,
                  color: "rgba(72, 83, 32,100)",
                },
                {
                  offset: 1,
                  color: "rgb(10, 12,4, 100)",
                },
              ]),
            },
            // data: this.Burnednumarr,
            data: this.Bonusnumarr,
          },
          {
            type: "line",
            stack: "Total",
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              width: 1,
              color: "#00E79A",
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            showSymbol: false,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(3, 70, 48,100)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 13, 9,100)",
                },
              ]),
            },
            data: this.Burnednumarr,
            //  data: this.Bonusnumarr,
          },
        ],
      };
      this.lineChart.clear();
      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.chart_xright {
  width: 974px;
  height: 161px;
}
</style>
